module.exports = __webpack_public_path__ + "static/seo-257f5030e8c4ea7b2a83874dda5bfc51.jpg";